export const ACTIONS = {
  RESET_CONFIRMATION: 'RESET_CONFIRMATION',
  CONFIRMATION_DIALOG_PENDING: 'CONFIRMATION_DIALOG_PENDING',
};

export const CONFIRMATION_DIALOG_MODAL_ID = 'CONFIRM_DIALOG';
